import { Action } from "redux";

import { ExtendedPropertiesType, TagsType } from "@multiweb/types/multiweb";
import { TypedObject } from "@multiweb/types/react";
import { DELETE_FORM, INIT_FORM } from "./constants";

/**
 * Obsahuje informace o formuláři potřebné v react části aplikace.
 */
export interface IFormState {
    /** ExtendedProperties daného formuláře. */
    readonly extendedProperties: ExtendedPropertiesType;
    /** Tags daného formuláře. */
    readonly tags: TagsType;
}

/**
 * Definice stavu pro mapu formulářů.
 */
export type FormsMapState = TypedObject<IFormState>;

/**
 * Pomocná akce, kterou musí rozšiřovat akce, které jsou mapovány
 * na jednotlivé instance `ReactFrame`.
 */
export interface IFormMappedAction<A = string> extends Action<A> {
    readonly meta: {
        readonly formKey: string;
    };
}

export class IFormMappedAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance?.meta?.formKey;
    }
}

/**
 * Akce pro smazání formu.
 */
export interface IDeleteFormAction extends IFormMappedAction<typeof DELETE_FORM> { }

export class IDeleteFormAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance instanceof IFormMappedAction && instance.type === DELETE_FORM;
    }
}

/**
  * Akce pro inicializaci formu.
  */
export interface IInitFormAction extends IFormMappedAction<typeof INIT_FORM> {
    readonly payload: {
        readonly extendedProperties: ExtendedPropertiesType;
        readonly tags: TagsType;
    };
}

export class IInitFormAction {
    public static [Symbol.hasInstance](instance: any): boolean {
        return instance instanceof IFormMappedAction && instance.type === INIT_FORM;
    }
}
